export enum PollTabs {
  PUBLICATED = 'publicated',
  UNPUBLICATED = 'unpublicated',
  ARCHIVE = 'archive',
}

export enum SearchKeysPoll {
  SEARCH_NAME = 'searchName',
  SEARCH_TITLE = 'searchTitle',
  SEARCH_DATE = 'searchDate',
  SEARCH_ID = 'byId',
}

export enum PollAnswerType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

export enum PollTabsRus {
  PUBLICATED = 'Опубликована',
  UNPUBLICATED = 'Не опубликовано',
  ARCHIVE = 'В архиве',
}

export const PollTabsToRus = {
  [PollTabs.PUBLICATED]: PollTabsRus.PUBLICATED,
  [PollTabs.UNPUBLICATED]: PollTabsRus.UNPUBLICATED,
  [PollTabs.ARCHIVE]: PollTabsRus.ARCHIVE,
};
